import { useCrud } from 'core/types/hooks'

import { DEBUGGER_CRUD, DEBUGGER_CRUD_NEW } from '../constants'

export const useDebuggerCrud = <T = any>(key: string, instanceId?: string) => {
  return useCrud<T>({ data: { ...DEBUGGER_CRUD, ...DEBUGGER_CRUD_NEW }, key, instanceId })
}
